<template>
  <div class="PlayerComp"> 
    <audio id="myAudio" :src="require('@/commons/mp3/chen.mp3')"></audio>
  </div>
</template>

<script>

import gsap from "gsap"
import { Howl, Howler } from 'howler'

export default {

  name: 'PlayerComp',
  render: h => h(),
  data: ()=>({
    ready: false
  }),
  beforeDestroy() {
    this.$audio.pause()
    this.$audio.removeEventListener('ended', this.audioEnded)
    this.$audio.remove()
  },
  mounted() {
    this.$audio = document.getElementById('myAudio')
    this.$audio.addEventListener('ended', this.audioEnded)
    gsap.delayedCall(1.25, ()=> this.listenAudio())
  },
  methods: { 

    audioEnded() {
      this.$parent.$parent.audioCompleted()
    },

    listenAudio() {
      this.$audio.play()
      this.visualizeTrack(this.$audio)
    },

    visualizeTrack(stream){
      if(!this.audioCtx) {
        this.audioCtx = new AudioContext()
      }
      const source = this.audioCtx.createMediaElementSource(stream)
            source.connect(this.audioCtx.destination)
      this.analyser = this.audioCtx.createAnalyser()
      this.analyser.fftSize = 2048
      this.bufferLength = this.analyser.frequencyBinCount
      this.dataArray = new Uint8Array(this.bufferLength)
      source.connect(this.analyser)
      this.raf = requestAnimationFrame(this.draw); 
    },

    draw() {
      this.raf = requestAnimationFrame(this.draw)
      this.analyser.getByteTimeDomainData(this.dataArray)
      for(let i = 0; i < this.bufferLength; i++) {
        let v = this.dataArray[i] / 128.0;
        this.$parent.analyser = v
      }
    }
  }

}
</script>


<style lang="stylus">
@import '~@/config/Settings'

.PlayerComp 
  position absolute
 
</style>


